/**
 * Number of days to look back when backfilling historical order trackers for
 * a newly-enabled merchant/shop. Used by both V1 (sync-team-trackers) and V2
 * (OTv2 backfill workflow) order tracking.
 */
export const ORDER_TRACKING_BACKFILL_DAYS = 24;
